import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
export function AltaDemandaSection() {
  const reasons = ['Decoración artesanal', 'Productos personalizados', 'Regalos únicos', 'Arte hecho a mano', 'Diseños exclusivos'];
  return <section className="py-8 md:py-12 px-4 bg-white" data-id="element-19">
      <div className="max-w-3xl mx-auto" data-id="element-20">
        <div className="text-center mb-4" data-id="element-21">
          <div className="inline-block bg-red-100 text-red-600 font-bold px-3 py-0.5 rounded-full text-xs mb-2" data-id="element-22">
            🔥 ALTA DEMANDA
          </div>
          <h2 className="font-heading text-xl md:text-2xl text-brand-dark font-bold" data-id="element-23">
            🎨 ¿POR QUÉ EL PUNCH NEEDLE ESTÁ CRECIENDO TANTO?
          </h2>
        </div>

        <p className="text-center text-brand-text text-base mb-4" data-id="element-24">
          Porque las personas buscan cada vez más:
        </p>

        <div className="bg-brand-cream/50 rounded-2xl p-5 border border-brand-cream mb-4" data-id="element-25">
          <ul className="space-y-2.5 max-w-sm mx-auto" data-id="element-26">
            {reasons.map((reason, i) => <li key={i} className="flex items-center gap-3" data-id="element-27">
                <CheckCircleIcon className="text-brand-pink" fontSize="small" data-id="element-28" />
                <span className="font-medium text-brand-dark text-base" data-id="element-29">
                  {reason}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="text-center text-base" data-id="element-30">
          <p className="text-brand-text mb-1" data-id="element-31">
            Mientras la mayoría compra decoración genérica...
          </p>
          <p className="font-bold text-brand-purple" data-id="element-32">
            Vos podés crear piezas únicas con tus propias manos.
          </p>
        </div>
      </div>
    </section>;
}